(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collapsible"] && !Shopify.designMode) return;
  try {
    // Theme editor: open the panel when the merchant selects this block,
// so its content is visible while they edit it.
document.addEventListener('shopify:block:select', function (event) {
  var root = event.target;
  if (!root || !root.querySelector) return;
  var panel = root.matches('details.bp-collapsible')
    ? root
    : root.querySelector('details.bp-collapsible');
  if (panel) panel.open = true;
});
  } catch(e) { console.error(e); }
})();

})();
